export const Routes = {
    onlineBooking: '/',
    notFound: '/not-found',
    bookingResults: '/booking/:bookingId',
}
